import { render, staticRenderFns } from "./DiscountVehicle.vue?vue&type=template&id=7736ddd0&"
import script from "./DiscountVehicle.vue?vue&type=script&lang=js&"
export * from "./DiscountVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports